export default {
    intro: 'Use consonant hints and definitions to figure out the vocabulary!',
    meaning: 'Meaning',
    example: 'Example',
    table: {
        question: 'Vocabulary',
        emptyMessage: 'No content available.',
        answerRate: 'Answer Rate',
    },
    student: {
        selectionGuide: 'Can you figure out the word from these clues?',
        know: 'I know!',
        dontKnow: "I don't know",
        submit: 'Submit',
        next: 'Next',
        inputGuide: 'Type the word you think it is!',
        inputPlaceholder: 'Enter your answer',
        meaningN: 'Meaning {n}',
        imageN: 'Image {n}',
        videoN: 'Video {n}',
        additionalMaterials: 'More Resources',
    },
    result: {
        myAnswer: 'My answer:',
        know: 'I know',
        dontKnow: "Don't know",
        dontKnowBracket: "(Don't know)",
    },
    stats: {
        mostIncorrect: 'Most missed vocabulary',
        vocabulary: 'Vocabulary',
        meaning: 'Meaning',
        accuracy: 'Accuracy',
        moreN: 'and {n} more',
    },
    reactions: {
        knowSelect: [
            'Oh! You seem confident!',
            "Great! Let's check it out!",
            'Nice! Let me see if you got it right!',
            'Awesome! What word could it be?',
            "Cool! Let's see the answer!",
        ],
        correct: [
            "That's correct! Great job!",
            'Wow! You nailed it!',
            "Right! That's amazing!",
            'Excellent! You got it exactly right!',
            'Well done! Really impressive!',
        ],
        dontKnowSelect: [
            "That's okay! Let's figure it out together!",
            "Don't worry! The example sentences will help!",
            "No problem! Let's look at the clues!",
        ],
        maxAttempts: "It's okay. Let's find out what this word is together!",
        maxAttemptsNext: "Let's see what the word is, and move on to the next one!",
    },
    teacher: {
        modal: {
            clearConfirm: {
                title: 'Clear all pending words?',
                message: 'All pending words will be removed. Continue?',
            },
            closeConfirm: {
                title: 'Discard your input?',
                message: 'Closing will discard all words in the pending list. Continue?',
            },
            questionDelete: {
                title: 'Delete this question?',
                // {word}: the headword of the question to be deleted. Warns that it will be permanently removed from the activity.
                message: "The question '{word}' will be removed from the activity. Continue?",
            },
            waitItemDelete: {
                title: 'Remove pending word?',
                // {word}: the pending word to be removed. Only removed from the queue; activity is not affected.
                message: "Remove '{word}' from the pending list. Continue?",
            },
            // {count}: number of words skipped due to duplicate dictionary entry
            duplicateNotice: '{count} word(s) already registered were not added.',
            // {count}: number of words skipped because they have no meaning
            skippedNotice: '{count} word(s) without meanings were not added.',
            // Confirmation when mixing empty-meaning words with valid ones
            mixedEmptyConfirm: {
                title: 'Register?',
                line1: '{empty} word(s) without meanings will not be added.',
                line2: 'Register only the remaining {valid} word(s)?',
            },
            // Notice when only empty-meaning words remain
            onlyEmptyNotice: {
                title: 'Cannot register',
                message: 'There are no words to register. Only words without meanings remain.',
            },
            registerFailed: 'Failed to add.',
        },
    },
};
